import React from "react";
import PageHero from "@/components/PageHero";
import PageMeta from "@/components/PageMeta";
import Marquee from "@/components/Marquee";
import { PILLARS, BRAND } from "@/data/brand";
import { Target, Compass, Rocket, Flag } from "lucide-react";

export default function About() {
  return (
    <div>
      <PageMeta
        title="About PSHL — Built Commercial"
        description="India's first commercially structured skate hockey league — engineered as a city-franchise system with sponsorships, academies, media and a long-term growth runway."
        image="/api/og/about/og-image.png"
      />
      <PageHero
        overline="About PSHL"
        title={<>India’s Pro Skate <br /> Hockey League. <span className="text-pshl-electric">Built Commercial.</span></>}
        subtitle="PSHL is India’s first commercially structured skate hockey league — engineered as a city-franchise system with sponsorships, academies, media and a long-term growth runway."
        bgImage="https://images.pexels.com/photos/15779126/pexels-photo-15779126.jpeg"
      />

      <section className="section">
        <div className="pshl-container grid lg:grid-cols-2 gap-10">
          <div className="bg-pshl-surface border border-white/10 p-8">
            <div className="h-10 w-10 grid place-items-center bg-pshl-electric/15 border border-pshl-electric/40"><Target className="h-5 w-5 text-pshl-electric" /></div>
            <h2 className="font-display text-3xl text-white mt-4">Mission</h2>
            <p className="mt-3 text-white/75 leading-relaxed">
              Commercialize and scale skate hockey in India as a premium franchise sport with
              world-class production, athlete pathways, and sponsor inventory.
            </p>
          </div>
          <div className="bg-pshl-surface border border-white/10 p-8">
            <div className="h-10 w-10 grid place-items-center bg-pshl-electric/15 border border-pshl-electric/40"><Compass className="h-5 w-5 text-pshl-electric" /></div>
            <h2 className="font-display text-3xl text-white mt-4">Vision</h2>
            <p className="mt-3 text-white/75 leading-relaxed">
              Make PSHL8 the most aspirational pro skate hockey league in Asia — a franchise
              system with city pride, global standards, and Indian heart.
            </p>
          </div>
        </div>
      </section>

      <Marquee text={`${BRAND.tagline} · ${BRAND.subTagline}`} />

      <section className="section">
        <div className="pshl-container">
          <div className="text-xs uppercase tracking-[0.32em] text-pshl-electric font-display mb-3">The PSHL8 Meaning</div>
          <h2 className="font-display text-4xl md:text-5xl text-white tracking-tighter">Eight Pillars. One Identity.</h2>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {PILLARS.map((p, i) => (
              <div key={p.key} className="bg-pshl-surface border border-white/10 p-5">
                <div className="font-mono text-[10px] tracking-[0.25em] text-pshl-electric">P{String(i+1).padStart(2,"0")}</div>
                <div className="font-display text-2xl text-white mt-2">{p.title}</div>
                <div className="text-sm text-white/65 mt-2 leading-relaxed">{p.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-[#08090E]">
        <div className="pshl-container grid lg:grid-cols-12 gap-8">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.32em] text-pshl-electric font-display mb-3">Why India · Why Now</div>
            <h2 className="font-display text-4xl md:text-5xl text-white tracking-tighter">A Sport with <br /><span className="text-gold-metallic">Massive Headroom.</span></h2>
          </div>
          <div className="lg:col-span-7 space-y-5 text-white/80 leading-relaxed">
            <p>India’s sports economy is in a once-in-a-generation phase of franchise commercialization. Skate hockey is fast, photogenic, urban, and gender-inclusive — a perfect fit for a city-franchise sport.</p>
            <p>PSHL is structured from day one as a commercial, sponsor-ready, broadcast-ready league. We are not building a tournament — we are building a sports platform.</p>
            <div className="grid sm:grid-cols-2 gap-3 mt-6">
              {[
                ["Audience", "16–45 yrs urban Tier 1+2"],
                ["Sport Profile", "Fast, photogenic, OTT-first"],
                ["Inclusion", "Mixed gender pathway"],
                ["Commercial", "Franchise + sponsor model"],
              ].map(([k, v]) => (
                <div key={k} className="border border-white/8 bg-white/[0.02] px-4 py-3">
                  <div className="text-[10px] uppercase tracking-[0.22em] text-white/55">{k}</div>
                  <div className="font-display text-white text-lg mt-1">{v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
